<template>
  <div class="w-full  overflow-y-auto bg-[#1A1A1A] select-none min-h-dvh" style="background-color: #1A1A1A;">
    <div class="w-full flex flex-col items-center">
      <NuxtImg src="/assets/images/index/bg.png" alt="bg" width="750" height="1018" class="w-full" format="webp" />
      <p class="w-[250px] text-white text-center min-h-10">
        {{ $t("index-only-web") }}
      </p>
    </div>
    <div class="flex flex-col py-10 items-center">
      <GradientsBtn @click="onCopy" @touchend="onCopy" text="picma.magictiger.ai" class="h-14">
        <template #suffix>
          <NuxtImg src="/assets/images/home/copy.svg" alt="copy" width="24" height="24" />
        </template>
      </GradientsBtn>
      <div class="flex flex-col items-center">
        <div class="mt-[30px] flex gap-2">
          <a href="https://apps.apple.com/us/app/picma-ai-photo-enhancer/id1599103406" target="_blank"
            @click="addEvent('mobile-down-appStore')">
            <NuxtImg src="/assets/images/index/appStore.png" alt="app store" width="142" height="40" />
          </a>
          <a href="https://play.google.com/store/apps/details?id=com.magictiger.ai.picma" target="_blank"
            @click="addEvent('mobile-down-googlePlay')">
            <NuxtImg src="/assets/images/index/googlePlay.png" alt="google play" width="142" height="40" />
          </a>
        </div>
      </div>
    </div>
  </div>
</template>
<script setup>
const { t } = useI18n();
function onCopy() {
  addEvent('mobile-url-copy')
  // 使用 Clipboard API 进行复制
  // navigator.clipboard.writeText("picma.magictiger.ai").then(() => {
  //   showToast(t("index-copy-dialog-title"));
  //   // alert(t("index-copy-dialog-title"));
  // }).catch(e =>{
  //   console.log('复制异常',e);
  //   showToast('666');
  // });
  const text = "picma.magictiger.ai";
  if (navigator.clipboard) {
    navigator.clipboard.writeText(text).then(() => {
    showToast(t("index-copy-dialog-title"));
  });
  } else {
    const textarea = document.createElement('textarea');
    textarea.value = text;
    document.body.appendChild(textarea);
    textarea.select();
    document.execCommand('copy');
    document.body.removeChild(textarea);
    showToast(t("index-copy-dialog-title"));
  }
}
function showToast(message) {
  const toast = document.createElement('div');
  toast.textContent = message;
  toast.style.position = 'fixed';
  toast.style.top = '50%';
  toast.style.left = '50%';
  toast.style.transform = 'translateX(-50%)';
  toast.style.backgroundColor = 'rgba(0, 0, 0, 0.7)';
  toast.style.color = 'white';
  toast.style.padding = '10px 20px';
  toast.style.borderRadius = '25px';
  toast.style.zIndex = '10';
  document.body.appendChild(toast);
  setTimeout(() => {
    document.body.removeChild(toast);
  }, 3000); // 3秒后自动消失
}

function addEvent(eventName) {
  useLogEvent({ eventName });
}
</script>
<style scoped lang="scss"></style>
